import beraAvatar from "@/assets/bera-ai-avatar.jpg";
import { cn } from "@/lib/utils";

interface BeraAvatarProps {
  size?: "sm" | "md" | "lg" | "xl";
  showStatus?: boolean;
  className?: string;
}

const sizes = {
  sm: "h-7 w-7",
  md: "h-10 w-10",
  lg: "h-14 w-14",
  xl: "h-20 w-20",
};

export const BeraAvatar = ({ size = "md", showStatus = false, className }: BeraAvatarProps) => {
  return (
    <div className={cn("relative inline-block", className)}>
      <img
        src={beraAvatar}
        alt="Bera — Assistente BeraStays"
        loading="lazy"
        width={1024}
        height={1024}
        className={cn(
          "rounded-full object-cover ring-2 ring-background shadow-md",
          sizes[size],
        )}
      />
      {showStatus && (
        <span className="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full bg-emerald-500 ring-2 ring-background" />
      )}
    </div>
  );
};

export default BeraAvatar;
